import React from 'react';

import styles from './Sidebar.module.css';
import logoBCWhite from './../../../assets/common/logo-salut-parc-tauli-blanc.svg';
import { FaClipboardList } from 'react-icons/fa';
import { IoMdMap, IoMdSettings } from 'react-icons/io';
import { MdPerson, MdOutlineLogout, MdOutlineOpenInFull } from 'react-icons/md';
import doctorSVG from '../../../assets/icons/doctor.svg';

import { getUser } from '../../../services/Auth';
import { canAccessUbikare } from '../../../services/user';

import GeneralContext from '../../../context/GeneralContext';

import { useContext } from 'react';

// Components
import DynamicSVG from '../../Helpers/DynamicSVG/DynamicSVG';
import SidebarButton from '../../UI/SidebarButton/SidebarButton';
import LanguageDropdown from '../LanguageDropdown/LanguageDropdown';
import Help from '../../Helpers/Help/Help';

import { useTranslation } from 'react-i18next';

import { useLocation } from 'react-router-dom';

const Sidebar: React.FC<{
    modalSidebar?: boolean,
}> = ({ modalSidebar }) => {

    const { t } = useTranslation();

    const generalContext = useContext(GeneralContext);
    const user = getUser();

    const location = useLocation();

    const getCurrentLocationSidebar = () => {
        const path = location.pathname.split('/home/')[1].split('/')[0];
        return path;
    };

    const handleOpenInFull = () =>
        generalContext.setOpenSidebar(prev => !prev);

    const setActive = () => {
        if (modalSidebar) generalContext.setOpenSidebar(false);
    };

    const activeButton = getCurrentLocationSidebar();

    const displaySidebar = !generalContext.openSidebar ? 'none' : undefined;

    const accessUbk = canAccessUbikare();

    const buttonsSidebar = [
        { id: 'patients', label: t('patients'), link: '/home/patients', icon: <MdPerson key={0} /> },
        {
            id: 'staff', label: t('staff'), link: 'https://bettercare.spa.ubikare.io/',
            icon: <DynamicSVG src={doctorSVG} color='currentColor' key={5} />, props: { target: '_blank', rel: 'noopener noreferrer', disabled: !accessUbk }
        },
        { id: 'polls', label: t('polls'), link: '/home/polls', icon: <FaClipboardList key={2} /> },
        { id: 'routes', label: t('routes'), link: '/home/routes/routes_map_patients', icon: <IoMdMap key={3} /> },
        { id: 'administration', label: t('administration'), link: '/home/administration', icon: <IoMdSettings key={4} /> },
        { id: 'logout', label: t('logout'), link: '/logout', icon: <MdOutlineLogout key={5} /> },
    ] as const;


    return (
        <div className={styles.sidebarContainer} style={{ display: displaySidebar }}>
            <div className={styles.sidebar}>
                <div>
                    <div className={styles.OpenInFullIconContainer}>
                        <button onClick={handleOpenInFull}>
                            <MdOutlineOpenInFull className={styles.OpenInFullIcon} />
                        </button>
                    </div>
                    <div className={styles.logoWrapper}>
                        <a
                            className={styles.anchorLogo}
                            target="_blank"
                            rel="noreferrer"
                            href="https://bettercare.es/"
                        >
                            <img
                                src={logoBCWhite}
                                alt='logo hospital'
                                className={styles.logoHospital}
                            />
                        </a>
                    </div>
                </div>
                <div className={styles.sidebarButtons}>
                    <div className={styles.greetingUser}>
                        <p className={styles.userName}>
                            {t('hi')}{user ? ', ' + user.first_name : ''}!
                        </p>
                    </div>
                    {buttonsSidebar.map(buttonSidebar => !window.config.HIDE_SIDEBAR_MENU_BUTTONS.includes(buttonSidebar.id) &&
                        <SidebarButton
                            key={buttonSidebar.id}
                            disabled={window.config.DISABLED_SIDEBAR_MENU_BUTTONS.includes(buttonSidebar.id)}
                            active={activeButton === buttonSidebar.id}

                            handleClick={setActive}
                            buttonInfo={buttonSidebar}
                        />
                    )}
                </div>
                <div className={styles.versionApp}>
                    <LanguageDropdown />
                    <Help />
                </div>
            </div>
        </div >

    );
};

export default Sidebar;